import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import Content from 'components/Content';
import SearchBar from 'components/common/SearchBar';
import BundleLevelBar from 'components/common/BundleLevelBar';
import BundleList from 'components/bundles/BundleList';
import './Category.scss';

import { asyncFilterBundlesByCateg } from 'actions/bundles';

export class Category extends Component {
  componentDidMount() {
    this.load();
  }

  componentDidUpdate() {
    this.load();
    const { categ } = this.props.match.params;
    if (categ) {
      document.title = `Doodly: ${categ} Bundles`;
    }
  }

  load = () => {
    const { categ } = this.props.match.params;
    const { categories, fetchBundlesByCateg, currentCategId } = this.props;
    const categId = categories.find(c => c.name === categ).id;

    if (categId !== currentCategId) {
      fetchBundlesByCateg(categId);
    }
  };

  render() {
    const { categ, subcateg } = this.props.match.params;
    return (
      <div className="category d-flex flex-column">
        <Header />
        <Content>
          <div className="d-flex flex-column align-items-center">
            <SearchBar className="mt-3" />
            <BundleLevelBar className="mt-2" />
          </div>

          <div className="breadcrumbs">
            <Link to="/">Home</Link>
            <span className="sep">&gt;</span>
            <span>{categ}</span>
          </div>
          <div className="sheet">
            <h2 className="text-center mt-3 mb-5">
              {subcateg} {categ} Bundles
            </h2>
            <BundleList />
          </div>
        </Content>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { bundles, categories } = state;
  return {
    bundles: bundles.list,
    categories,
    currentCategId: bundles.categId
  };
};

const mapDispatchToProps = dispatch => ({
  fetchBundlesByCateg: categId => dispatch(asyncFilterBundlesByCateg(categId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Category);
